import React, { Component } from "react";
import classnames from "classnames";
import styles from "./Analytics.scss";

class LocationStats extends Component {
	constructor(props) {
		super(props);
		this.state = {
			docs: []
		};
	}

	componentDidMount = () => {
		this.setData();
	};

	setData = () => {
		let data = this.props.data;
		let results = [];
		for (var key in data.details) {
			let temp = {
				city: key,
				amount: data.details[key],
				percentage: (data.details[key] / data.total) * 100
			};
			results.push(temp);
		}
		this.setState({
			docs: results
		});
	};

	render() {
		return (
			<div className={styles.locationstats}>
				<h3>Visitors Location Stats</h3>
				<div className="table-responsive">
					<table className="table">
						<thead>
							<tr>
								<th>No.</th>
								<th>City</th>
								<th>Amount</th>
								<th>Percentage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.docs.map((item, i) => (
								<tr key={i}>
									<td>{i+1}</td>
									<td>{item.city}</td>
									<td>{item.amount}</td>
									<td>
										<div
											className={classnames(
												"progress",
												styles.progress
											)}
										>
											<div
												className="progress-bar bg-info"
												role="progressbar"
												style={{
													width: `${item.percentage}%`
												}}
												aria-valuenow={item.percentage}
												aria-valuemin="0"
												aria-valuemax="100"
											>
												{Math.round(item.percentage)}%
											</div>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

export default LocationStats;



// WEBPACK FOOTER //
// ./src/components/pages/Analytics/LocationStats.js